import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Pagination, Stack } from '@mui/material';

const EnhancedPagination = ({ pagination, onPageChange }) => {
    const { t } = useTranslation();
    const { page, totalPages, total, limit } = pagination;

    if (!totalPages || totalPages <= 1) {
        return null; // Don't render pagination if there's only one page or less
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3, flexDirection: 'column', gap: 2 }}>
            <Stack direction="row" spacing={2} alignItems="center">
                <Typography variant="body2" color="text.secondary">
                    {t('common.page')} {page} {t('common.of')} {totalPages}
                </Typography>
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={onPageChange}
                    color="primary"
                    showFirstButton
                    showLastButton
                />
            </Stack>
            <Typography variant="caption" color="text.secondary">
                {t('common.showingItems', {
                    start: ((page - 1) * limit) + 1,
                    end: Math.min(page * limit, total),
                    total: total
                })}
            </Typography>
        </Box>
    );
};

export default EnhancedPagination;